import React, { useState } from 'react';
import { ChevronDown, ChevronUp, BarChart3 } from 'lucide-react';
const faqs = [{
  question: '¿Necesito ganar mucho dinero?',
  answer: 'No, el sistema funciona con lo que ya tienes. Se trata de reestructurar tu flujo de caja actual, no de depender de un aumento de sueldo.'
}, {
  question: '¿Tengo que dejar de comer fuera?',
  answer: "No permanentemente, solo usamos la 'Semana de Consumo Cero' para el arranque inicial y generar el primer impulso de liquidez."
}, {
  question: '¿Es legal?',
  answer: '100%, solo estamos gestionando tus propias cuentas bancarias con una estructura más inteligente y defensiva.'
}, {
  question: '¿Tengo que cambiar de banco?',
  answer: 'No es obligatorio, pero es recomendable abrir una cuenta secundaria gratuita en otra institución para crear fricción psicológica y evitar que toques el dinero.'
}, {
  question: '¿Qué pasa si tengo deudas?',
  answer: 'El Arca es lo primero; sin un escudo de $500, cualquier deuda que pagues volverá a crecer ante la primera emergencia. Primero te blindas, luego atacas la deuda.'
}];
export function ProofSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 lg:py-32 bg-cream text-navy-dark" data-id="element-152">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl" data-id="element-153">
        {/* Proof Block */}
        <div className="bg-navy text-cream rounded-3xl p-8 md:p-12 shadow-2xl mb-20 relative overflow-hidden" data-id="element-154">
          <div className="absolute top-0 right-0 opacity-10" data-id="element-155">
            <BarChart3 className="w-64 h-64 -mt-10 -mr-10" data-id="element-156" />
          </div>
          <div className="relative z-10" data-id="element-157">
            <h2 className="font-heading text-3xl md:text-4xl font-bold mb-6 text-white" data-id="element-158">
              Resultados Predecibles
            </h2>
            <p className="text-lg md:text-xl text-cream-dark leading-relaxed mb-6" data-id="element-159">
              En los primeros 7 días de aplicar el Escaneo de Activos y la
              Matriz de Gasto Parásito, el lector promedio identifica entre{' '}
              <strong className="text-gold" data-id="element-160">$150 y $300 de capital</strong> que
              estaba siendo desperdiciado o que estaba "congelado" en objetos
              inútiles.
            </p>
            <p className="text-lg md:text-xl text-cream-dark leading-relaxed font-medium" data-id="element-161">
              Al día 30, la sensación de pánico ante el teléfono desaparece.
            </p>
          </div>
        </div>

        {/* FAQ Accordion */}
        <div data-id="element-162">
          <h2 className="font-heading text-3xl font-bold text-center mb-10 text-navy" data-id="element-163">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-4" data-id="element-164">
            {faqs.map((faq, index) => <div key={index} className={`bg-white rounded-xl border transition-all duration-300 ${openIndex === index ? 'border-gold shadow-md' : 'border-cream-dark'}`} data-id="element-165">
                <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} data-id="element-166">
                  <span className="font-bold text-navy pr-4" data-id="element-167">
                    {faq.question}
                  </span>
                  {openIndex === index ? <ChevronUp className="text-gold shrink-0" data-id="element-168" /> : <ChevronDown className="text-gray-400 shrink-0" data-id="element-169" />}
                </button>

                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-170">
                  <p className="text-gray-600 leading-relaxed" data-id="element-171">{faq.answer}</p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}